// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"f6070436","289":"541c9d7b","787":"3e838beb","902":"fc8886d0"}[chunkId] + ".chunk.js";
};